import { httpPost, httpDownload } from '../../../utils/api.utils';
import { DEFAULT_TABLE_RESULT_MODEL, REPORT_COLUMN_MODULE } from '../../../constants/external-constants';
import { convertToFormatTimeZoneDate } from '../../../utils/helpers.utils';

import {
    getManageUser
    ,setDefaultManageUser
    ,setManageUserError
    ,setManageUserColSearchStr
    ,sortManageUserList
    ,setManageUserListPageSizes
    ,setManageUserFilter
    ,applyManageUserFilter
} from "../../../constants/model-reducers/external/manage-user/manage-user.settings";

const defaultState = () => ({
    isManageUserLoaded: false,
    isManageUserError: false,
    manageUserList: DEFAULT_TABLE_RESULT_MODEL,
    manageUserColSort: '',
    manageUserIsSortedAsc: true,
    //Manage User Filters
    manageUserFilterData: [],
    manageUserFilterLoaded: false,
    manageUserTableFilterList: [],
    manageUserTableFilterApply: false,
});

const initialState = defaultState();

export const manageUserActions = {
    setDefaultManageUser: () => async (dispatch, state) => {
        dispatch({
            type: setDefaultManageUser,
            employeeList: DEFAULT_TABLE_RESULT_MODEL
        });
    },

    getManageUser: (pageIndex = 0, pageUnmount = false) => async (dispatch, state) => {
        const { Headers, Pagination } = state().manageUser.manageUserList;
        const { manageUserColSort, manageUserIsSortedAsc, manageUserTableFilterList, manageUserTableFilterApply } = state().manageUser;

        const headersToSend = pageUnmount ? {} : { ...Headers };

        try {
            var data = {
                PageFilter: {
                    PageIndex: pageIndex !== undefined ? pageIndex : 0,
                    PageSize: Pagination.PerPage,
                    PageSizes: Pagination.PageSizes
                },
                Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
                UserId: sessionStorage.getItem('UserID'),
                EmployeeId: sessionStorage.getItem('EmployeeID'),
                Headers: headersToSend,
                SortedColumnName: manageUserColSort,
                IsSortAscending: manageUserIsSortedAsc,
                TableFilterList: manageUserTableFilterList,
                ApplyFilter: manageUserTableFilterApply
            };

            var employeeList = await httpPost('external/manageUser/getAllEmployeeList', data);

            dispatch({
                type: getManageUser,
                employeeList: Object.keys(employeeList).length > 0 ? employeeList : DEFAULT_TABLE_RESULT_MODEL,
                isManageUserLoaded: true,
                isManageUserError: false
            });
        }
        catch (e) {
            dispatch({
                type: setManageUserError,
                isManageUserError: true,
                isManageUserLoaded: false
            })
        }
    },

    extractAllUser: () => async (dispatch, state) => {
        const { Headers } = state().manageUser.manageUserList;
        const { manageUserColSort, manageUserIsSortedAsc, manageUserTableFilterApply, manageUserTableFilterList } = state().manageUser;
        const dealName = sessionStorage.getItem('DealName');
        const { activeDateFormat, activeTimeZoneOffset } = state().adminSetting;

        const formattedTimeZoneDate = convertToFormatTimeZoneDate(
            new Date(),
            activeDateFormat?.Name || "YYYY-MM-DD",
            activeTimeZoneOffset?.UtcOffset || 0)
            .replace(/[<>:"/\|?*]/g, '-');
        const filename = `ATEM ${dealName} User Extract – ${formattedTimeZoneDate}`;       

        var data = {
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: {
                ...Headers
            },   
           
            SortedColumnName: manageUserColSort,
            IsSortAscending: manageUserIsSortedAsc,
            TableFilterList: manageUserTableFilterList,
            ApplyFilter: manageUserTableFilterApply,
            SortedColumnName: manageUserColSort,

            
           
        };
        httpDownload('external/manageUser/getAllUsersExtractItems', data)
            .then(function (response) {
                return response.blob();
            })
            .then(function (blob) {
                let downloadUrl = window.URL.createObjectURL(blob);
                //Hide Loading
                let a = document.createElement('a');
                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else if (typeof a.download === 'undefined') {
                    window.location = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename + '.xlsx';
                    document.body.appendChild(a);
                    a.click();
                }
            });
    },

    setManageUserColSearchStr: (event, key) => async (dispatch, state) => {
        var val = event.target.value;
        const { manageUserList } = state().manageUser;
        var manageUserListUpd = {
            ...manageUserList,
            "Headers": {
                ...manageUserList.Headers,
                [key]: {
                    ...manageUserList.Headers[key],
                    searchString: val
                }
            }
        }

        dispatch({
            type: setManageUserColSearchStr,
            data: manageUserListUpd,
            isManageUserLoaded: true,
            isManageUserError: false
        });
    },

    sortManageUserList: (columnClicked, isSortedAsc) => async (dispatch, state) => {
        const { PageNumber, PageSizes } = state().manageUser.manageUserList.Pagination;
        const { manageUserList, manageUserTableFilterList, manageUserTableFilterApply } = state().manageUser;

        var data = {
            PageFilter: {
                PageIndex: PageNumber !== undefined ? PageNumber : 0,
                PageSize: manageUserList.Pagination.PerPage,
                PageSizes: PageSizes
            },
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: {
                ...manageUserList.Headers
            },
            SortedColumnName: columnClicked,
            IsSortAscending: isSortedAsc,
            TableFilterList: manageUserTableFilterList,
            ApplyFilter: manageUserTableFilterApply
        };

        var resManageUserList = await httpPost('external/manageUser/getAllEmployeeList', data);
        if (resManageUserList.ok === false) {
            dispatch({
                type: setManageUserError,
                isManageUserError: true,
                isManageUserLoaded: false
            });
        } else {
            dispatch({
                type: sortManageUserList,
                manageUserList: Object.keys(resManageUserList).length > 0 ? resManageUserList : DEFAULT_TABLE_RESULT_MODEL,
                manageUserColSort: columnClicked,
                manageUserIsSortedAsc: isSortedAsc,
                isManageUserLoaded: true
            })
        }
    },

    resizeManageUserPage: (pageSize) => async (dispatch, state) => {
        dispatch({
            type: setManageUserListPageSizes,
            pageSize: parseInt(pageSize),
        });
    },

    saveManageUserCustomCols: (selectedCols) => async (dispatch, state) => {
        const { Headers, Pagination } = state().manageUser.manageUserList;
        const { manageUserColSort, manageUserIsSortedAsc } = state().manageUser;

        try {
            var userId = sessionStorage.getItem('UserID');

            var customizeFormData = {
                UserId: parseInt(userId),
                ReportColumnModule: REPORT_COLUMN_MODULE.HRManagement,
                SelectedCols: selectedCols
            };

            await httpPost('external/manageUser/saveManageUserCustomizeColumns', customizeFormData)
            dispatch({
                type: setManageUserError,
                isManageUserError: true,
                isManageUserLoaded: false
            });

            var data = {
                PageFilter: {
                    PageIndex: 0,
                    PageSize: Pagination.PerPage,
                    PageSizes: Pagination.PageSizes
                },
                Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
                UserId: userId,
                EmployeeId: sessionStorage.getItem('EmployeeID'),
                Headers: {
                    ...Headers
                },
                SortedColumnName: manageUserColSort,
                IsSortAscending: manageUserIsSortedAsc
            };

            var employeeList = await httpPost('external/manageUser/getAllEmployeeList', data);

            dispatch({
                type: getManageUser,
                employeeList: Object.keys(employeeList).length > 0 ? employeeList: DEFAULT_TABLE_RESULT_MODEL,
                isManageUserLoaded: true,
                isManageUserError: false
            });
        }
        catch (e) {
            dispatch({
                type: setManageUserError,
                isManageUserError: true,
                isManageUserLoaded: false
            });
        }
    },

    addManageUserFilter: (tableFilter) => (dispatch, state) => {
        const { manageUserTableFilterList } = state().manageUser;
        var filterList = [...manageUserTableFilterList, tableFilter];

        dispatch({
            type: setManageUserFilter,
            filterList: filterList
        })
    },

    removeManageUserFilter: (removeIndex) => (dispatch, state) => {
        const { manageUserTableFilterList } = state().manageUser;

        var filterList = manageUserTableFilterList.filter((item, index) => {
            return index !== removeIndex;
        });

        dispatch({
            type: setManageUserFilter,
            filterList: filterList
        })
    },

    applyManageUserFilter: (isApply) => (dispatch, state) => {
        const { manageUserTableFilterList } = state().manageUser;

        dispatch({
            type: applyManageUserFilter,
            applyFilter: isApply,
            filterList: isApply ? manageUserTableFilterList : []
        });
    },
};

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case getManageUser:
            return {
                ...state,
                manageUserList: action.employeeList,
                isManageUserLoaded: action.isManageUserLoaded,
                isManageUserError: action.isManageUserError
            };
        case setManageUserError: 
            return {
                ...state,
                isManageUserLoaded: action.isManageUserLoaded,
                isManageUserError: action.isManageUserError
            };
        case setManageUserColSearchStr:
            return {
                ...state,
                manageUserList: action.data,
                isManageUserLoaded: action.isManageUserLoaded,
                isManageUserError: action.isManageUserError
            };
        case sortManageUserList:
            return {
                ...state,
                manageUserList: action.manageUserList,
                manageUserColSort: action.manageUserColSort,
                manageUserIsSortedAsc: action.manageUserIsSortedAsc,
                isManageUserLoaded: action.isManageUserLoaded
            };
        case setManageUserListPageSizes:
            return {
                ...state,
                manageUserList: {
                    ...state.manageUserList,
                    Pagination: {
                        ...state.manageUserList.Pagination,
                        PerPage: action.pageSize
                    }
                }
            };
        case setManageUserFilter:
            return {
                ...state,
                manageUserTableFilterList: action.filterList,
            };
        case applyManageUserFilter:
            return {
                ...state,
                manageUserTableFilterApply: action.applyFilter,
                manageUserTableFilterList: action.filterList
            };
        case setDefaultManageUser:
            return initialState;
        default:
            return state;
    }
}